import { createAction, props } from '@ngrx/store';
import { BatchQuery } from '../../models/batch-query';
import { Batch } from '../../models/batch';

export const batchTableRequest = createAction(
    '[Batch Table] Load Request'
);

export const batchTableSuccess = createAction(
    '[Batch Table] Load Response',
    props<{ totalCount: number, page: Batch[] }>()
);

export const batchTableFailure = createAction(
    '[Batch Table] Load Failure'
);

export const batchTableChangePage = createAction(
    '[Batch Table] Change Page',
    props<{ pageNumber: number, itemsPerPage: number }>()
);

export const batchTableChangeQuery = createAction(
    '[Batch Table] Change Filter',
    props<{ query: BatchQuery }>()
);

export const batchTableSort = createAction(
    '[Batch Table] Change Sort Column',
    props<{ id: string, descending: boolean }>()
);

export const batchTableSetSelection = createAction(
    '[Batch Table] Set Selection',
    props<{ selection: string[] }>()
);

export const batchTableMasterToggle = createAction(
    '[Batch Table] Master Selection Toggle'
);

export const batchTableToggle = createAction(
    '[Batch Table] Toggle Selection',
    props<{ id: string }>()
);

export const batchTableAddAssist = createAction(
    '[Batch Table] Add Filter Assist',
    props<{ id: string, parameter: any }>()
);

export const batchTableRemoveAssist = createAction(
    '[Batch Table] Remove Filter Assist',
    props<{ id: string }>()
);
